import React, { Suspense, lazy } from "react";
import { Router, Route, Redirect, Switch } from "react-router-dom";
import AuthService from "../auth/AuthService";
import { AppLoading } from "../loaders/loaders";
import PrivateRouteComponent from "./privateRoute";
import history from "../utilities/history";
import {  withAITracking } from '@microsoft/applicationinsights-react-js';
import appConstants from "../appConstants";

const RouteRendererComponent = lazy(()=>import("./routeRenderer"));
const LoginForm = lazy(()=> import("../components/login/loginForm"));
const PageNotFound = lazy(()=> import("../components/PageNotFound"));
const ServerError = lazy(()=> import("../components/PageNotFound/ServerError"));
const AccessDenied = lazy(()=> import("../components/PageNotFound/AccessDenied"));

const RouteContext = (props) => {
    const { NAV_URLS } = appConstants;
    return (
        <Router history={history}>
            <Suspense fallback={<AppLoading />}>
                <Switch>
                    <Route exact path={NAV_URLS.HOME}
                        render={()=>{
                            return AuthService.isLoggedIn() ? <Redirect to={NAV_URLS.IBPLANNING_HOME} /> : <LoginForm onProfileUpdate={props.userProfileUpdate}/>
                        }}/>
                    <Route path={NAV_URLS.LOGIN}
                        render ={ ()=> {
                            return AuthService.isLoggedIn() ? <Redirect to={NAV_URLS.IBPLANNING_HOME} /> : <LoginForm onProfileUpdate={props.userProfileUpdate}/>
                    }} />
                    <Route exact path={NAV_URLS.PATH_MATCHERS.RESET_PASSWORD}
                        render ={ ()=>{
                            return AuthService.isLoggedIn() ? <Redirect to={NAV_URLS.IBPLANNING_HOME} /> : <LoginForm resetPassword />
                        }} />
                    <Route exact path={NAV_URLS.IBPLANNING_HOME}
                        render ={ ()=>( <Redirect to={NAV_URLS.IBPLANNING_SHIPMENTS} />)} />
                    <Route exact path={NAV_URLS.REPORT_HOME}
                        render ={ () => (<Redirect to={NAV_URLS.REPORT_DUPLICATE_CUSTOMERS} />)} />
                    <Route exact path={NAV_URLS.DISPATCH_HOME} render={()=> (<Redirect to={NAV_URLS.DISPATCH_ROUTEEXECUTION} />)} />
                    {/* Commented below items since they are yet to be implmented and should throw 404 error for now */}
                    {/* 
                    <Route exact path="/Customers"
                    render ={ ()=>( <Redirect to="/Customers/Management" />)} />
                    <Route exact path="/Reports"
                    render ={ ()=>( <Redirect to="/Reports/KPIReports" />)} /> */}

                    {/* Setting up dynamic routes for all sub modules  */}
                    <PrivateRouteComponent path={NAV_URLS.PATH_MATCHERS.IBPLANNING} component={RouteRendererComponent} />
                    {/* Commented below items since they are yet to be implmented and should throw 404 error for now */}
                    <PrivateRouteComponent path={NAV_URLS.PATH_MATCHERS.DISPATCH} component={RouteRendererComponent} />
                    {/* <PrivateRouteComponent path="/Customers/:moduleName" component={RouteRendererComponent} />
                    <PrivateRouteComponent path="/Reports/:moduleName" component={RouteRendererComponent} /> */}
                    <PrivateRouteComponent path={NAV_URLS.SETTINGS} component={RouteRendererComponent} />
                    <PrivateRouteComponent path={NAV_URLS.SHIPMENT_SELECTION} component={RouteRendererComponent} />
                    <PrivateRouteComponent path={NAV_URLS.PATH_MATCHERS.REPORTS} component={RouteRendererComponent} />
                    <PrivateRouteComponent path={NAV_URLS.PAGE_NOT_FOUND} component={PageNotFound}/>
                    <PrivateRouteComponent path={NAV_URLS.SERVER_ERROR} component={ServerError}/>
                    <PrivateRouteComponent path={NAV_URLS.ACCESS_DENIED} component={AccessDenied}/>
                    <Route render={ ()=>( <Redirect to={NAV_URLS.PAGE_NOT_FOUND} />)} />
                </Switch>
            </Suspense>
        </Router>
    )
}
//export default withAITracking(ai, RouteContext); -> This information we don't need right now
export default  RouteContext;